module.exports = __webpack_public_path__ + "img/sk.7365349f.svg";